import { Button, Modal, Tooltip } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import CreateEmailSender from "../../pages/protected/tools/emails/components/CreateEmailSender";
import { useLanguage } from "../../stores/LanguageStore";

const AddEmailSender = ({ onCreated }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure(false);

  return (
    <>
      <Tooltip label={lang.campaign.panel.email.tooltip}>
        <Button
          variant="subtle"
          size="compact-sm"
          onClick={open}
          type="button"
          fw={700}
        >
          {lang.campaign.panel.email.label}
        </Button>
      </Tooltip>

      <Modal
        opened={opened}
        onClose={close}
        title={lang.campaign.panel.email.title}
        size={"auto"}
        styles={{
          header: {
            paddingBottom: 8,
            minHeight: 32,
          },
        }}
        removeScrollProps={{
          enabled: false,
        }}
        radius={"md"}
        zIndex={999}
      >
        <CreateEmailSender onCreated={onCreated} handleClose={close} />
      </Modal>
    </>
  );
};

export default AddEmailSender;
